// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f15f1d09","488":"9552c097","732":"aafe04cc","977":"f24ee438"}[chunkId] + ".chunk.js";
};